import { getQuoteBackendValidationMessages } from "./quote";
import { types } from "./types";

export const setIsFinanceConfigured = payload => dispatch => {
  dispatch({
    type: types.SET_QUOTE_IS_FINANCE_CONFIGURED,
    payload
  })
  dispatch(getQuoteBackendValidationMessages())
};

export const setFinanceType = payload => (dispatch, getState) => {
  const state = getState()
  dispatch({
    type: types.SET_QUOTE_FINANCE_TYPE,
    payload
  })
  if(payload !== 'CASH' && state.quote.finance.financeSubtype == null) {
    dispatch(setFinanceSubtype("RENTAL"))
  }
  dispatch(getQuoteBackendValidationMessages());
};

export const setFinanceSubtype = payload => (dispatch) => {
  dispatch({
    type: types.SET_QUOTE_FINANCE_SUBTYPE,
    payload
  })
  dispatch(getQuoteBackendValidationMessages()); //For NZ, which is set by user
};

export const addPayoutInfoLine = payoutInfo => {
  if(payoutInfo.length > 2){
    return setPayoutInfo([...payoutInfo]);  
  }
  
  return setPayoutInfo([
    ...payoutInfo,
    {
      SupplierOrFinancer: "",
      ContractIdentifier: "",
      PayoutFunds: ""
    }
  ]);
}

export const deletePayoutInfoLine = (payoutInfo, rowIndex) =>
  setPayoutInfo([...payoutInfo].filter((item, index) => index !== rowIndex));

export const editPayoutInfoLine = (payoutInfo, rowIndex, colIndex, value) => {
  if(colIndex === 'PayoutFunds'){
    value = Number(Math.abs(value)) + ""
  }
  
  const updatePayoutInfo = [...payoutInfo];
  updatePayoutInfo[rowIndex][colIndex] = value.trim();
  return setPayoutInfo(updatePayoutInfo);
};

export const setOriginatorReference = originatorReference => ({
  type: types.SET_QUOTE_ORIGINATOR_REFERENCE,
  payload: originatorReference
});

export const setCanonCopyPlanType = payload => ({
  type: types.SET_QUOTE_CANON_COPY_PLAN_TYPE,
  payload
});

export const setCfaAmount = payload => ({
  type: types.SET_QUOTE_CFA_AMOUNT,
  payload
});

export const setTotalAmountFinanced = payload => ({
  type: types.SET_QUOTE_TOTAL_AMOUNT_FINANCED,
  payload
});

export const setAdjustmentPeriod = adjustmentPeriod => ({
  type: types.SET_QUOTE_ADJUSTMENT_PERIOD,
  payload: adjustmentPeriod
});

export const setCanonFinancePayout = canonFinancePayout => ({
  type: types.SET_QUOTE_CANON_FINANCE_PAYOUT,
  payload: canonFinancePayout
});

export const setCfaCcBw = cfaCcBw => ({
  type: types.SET_QUOTE_CFA_CC_BW,
  payload: cfaCcBw
});

export const setCfaCcBwAdjustClickChargePerMonthExclGst = cfaCcBwAdjustClickChargePerMonthExclGst => ({
  type: types.SET_QUOTE_CFA_CC_BW_ADJUST_CLICK_CHARGE_PER_MONTH_EXCL_GST,
  payload: cfaCcBwAdjustClickChargePerMonthExclGst
});

export const setCfaCcBwMinimumMonthlyClickVolume = cfaCcBwMinimumMonthlyClickVolume => ({
  type: types.SET_QUOTE_CFA_CC_BW_MINIMUM_MONTHLY_CLICK_VOLUME,
  payload: cfaCcBwMinimumMonthlyClickVolume
});

export const setCfaCcBwServiceCopyCost = cfaCcBwServiceCopyCost => ({
  type: types.SET_QUOTE_CFA_CC_BW_SERVICE_COPY_COST,
  payload: cfaCcBwServiceCopyCost
});

export const setCfaCcBwExcessFinancedCopyCost = cfaCcBwExcessFinancedCopyCost => ({
  type: types.SET_QUOTE_CFA_CC_BW_EXCESS_FINANCED_COPY_COST,
  payload: cfaCcBwExcessFinancedCopyCost
});

export const setCfaCcColour = cfaCcColour => ({
  type: types.SET_QUOTE_CFA_CC_COLOUR,
  payload: cfaCcColour
});

export const setCfaCcColourAdjustClickChargePerMonthExclGst = cfaCcColourAdjustClickChargePerMonthExclGst => ({
  type: types.SET_QUOTE_CFA_CC_COLOUR_ADJUST_CLICK_CHARGE_PER_MONTH_EXCL_GST,
  payload: cfaCcColourAdjustClickChargePerMonthExclGst
});

export const setCfaCcColourMinimumMonthlyClickVolume = cfaCcColourMinimumMonthlyClickVolume => ({
  type: types.SET_QUOTE_CFA_CC_COLOUR_MINIMUM_MONTHLY_CLICK_VOLUME,
  payload: cfaCcColourMinimumMonthlyClickVolume
});

export const setCfaCcColourServiceCopyCost = cfaCcColourServiceCopyCost => ({
  type: types.SET_QUOTE_CFA_CC_COLOUR_SERVICE_COPY_COST,
  payload: cfaCcColourServiceCopyCost
});

export const setCfaCcColourExcessFinancedCopyCost = cfaCcColourExcessFinancedCopyCost => ({
  type: types.SET_QUOTE_CFA_CC_COLOUR_EXCESS_FINANCED_COPY_COST,
  payload: cfaCcColourExcessFinancedCopyCost
});

export const setFinanceTerm = financeTerm => ({
  type: types.SET_QUOTE_FINANCE_TERM,
  payload: financeTerm
});

export const setInstalmentAmount = instalmentAmount => ({
  type: types.SET_QUOTE_INSTALMENT_AMOUNT,
  payload: instalmentAmount
});

export const setInstalmentType = instalmentType => ({
  type: types.SET_QUOTE_INSTALMENT_TYPE,
  payload: instalmentType
});

export const setPayableIn = payableIn => ({
  type: types.SET_QUOTE_PAYABLE_IN,
  payload: payableIn
});

export const setResidualValue = residualValue => ({
  type: types.SET_QUOTE_RESIDUAL_VALUE,
  payload: residualValue
});

export const setThirdPartyPayout = thirdPartyPayout => ({
  type: types.SET_QUOTE_THIRD_PARTY_PAYOUT,
  payload: thirdPartyPayout
});

export const setDeferredPayment = deferredPayment => ({
  type: types.SET_QUOTE_FINANCE_DEFERRED_PAYMENT,
  payload: deferredPayment
})

export const setPayoutInfo = payoutInfo => ({
  type: types.SET_QUOTE_PAYOUT_INFO,
  payload: payoutInfo
});
